import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeSquare } from '@fortawesome/free-solid-svg-icons/faEnvelopeSquare';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { Header, Text } from '@gasbuddy/react-components';
import { toQueryString } from '../../../lib/utils/querystring';

import styles from './SocialShareModal.module.css';

export default function SocialShareModal({
  title,
  message,
  emailParams,
  twitterParams,
  onShare,
}) {
  if (!emailParams && !twitterParams) {
    return null;
  }

  return (
    <Fragment>
      <Header as="h3">{title}</Header>
      <Text as="p">
        {message}
      </Text>
      <div className={styles.ctas}>
        {!!emailParams && (
          <a
            href={`mailto:?${toQueryString(emailParams)}`}
            onClick={() => { onShare('email'); }}
          >
            <FontAwesomeIcon icon={faEnvelopeSquare} name="email" size="2x" aria-hidden="true" />
          </a>
        )}
        {!!twitterParams && (
          <a
            href={`https://twitter.com/share?${toQueryString(twitterParams)}`}
            onClick={() => { onShare('twitter'); }}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon icon={faTwitter} name="twitter" size="2x" aria-hidden="true" />
          </a>
        )}
      </div>
    </Fragment>
  );
}

SocialShareModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  emailParams: PropTypes.shape({
    subject: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
  }),
  twitterParams: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  onShare: PropTypes.func.isRequired,
};

SocialShareModal.defaultProps = {
  emailParams: undefined,
  twitterParams: undefined,
};
